import { ArticleEntityAdminService } from './articleEntityAdminService';
import { PressRelease } from '@models/pressRelease';

export class PressReleaseAdminService extends ArticleEntityAdminService<PressRelease> {
    constructor() {
        super('/api/admin/press-release');
    }
}
